import { Stack } from 'expo-router';

export default function UserManagementLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false
      }}
    >
      <Stack.Screen name={'index'} />
      <Stack.Screen name={'[id]'} />
    </Stack>
  );
}
